var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_c('div',[(_vm.$slots['sidebar'])?_c('div',{staticClass:"tw-fixed tw-top-0 tw-w-[100px]"},[_vm._t("sidebar")],2):_vm._e(),_c('div',{staticClass:"tw-w-full",class:{ 'tw-pl-[100px]': _vm.$slots['sidebar'] }},[_vm._t("content")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }